export const calculatePercentageChange = ({
	previousBalance,
	currentBalance,
}: {
	previousBalance: string;
	currentBalance: string;
}) => {
	const previous = parseFloat(previousBalance);
	const current = parseFloat(currentBalance);
	const delta = current - previous;

	if (previous === 0) {
		return previous === 0 && current === 0 ? 0 : Infinity;
	}

	return (delta / Math.abs(previous)) * 100;
};
